module.exports = __webpack_public_path__ + "static/uiux-solitions2-06413d41ecda334002c248f92d4f8823.png";